import { render, staticRenderFns } from "./ViewMethodDataExtraction.vue?vue&type=template&id=cb9d88c0"
import script from "./ViewMethodDataExtraction.vue?vue&type=script&lang=js"
export * from "./ViewMethodDataExtraction.vue?vue&type=script&lang=js"
import style0 from "./ViewMethodDataExtraction.vue?vue&type=style&index=0&id=cb9d88c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports